import React from 'react';
import TextInput from './TextInput';

const DatePickerInput = React.forwardRef(function DatePickerInput(
  { value, onClick, error },
  ref
) {
  return (
    <TextInput
      ref={ref}
      value={value}
      onClick={onClick}
      type="text"
      className="cursor-pointer"
      error={error}
      readOnly
    />
  );
});

export default DatePickerInput;
